var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandle5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.986,
    height: 65,
    viewBox: "0 0 50.986 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "candle-5",
    transform: "translate(-55.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(55.195 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M98.351,60.761H90.862c9.325-7.924,15.319-13.692,15.319-21.938A15.444,15.444,0,0,0,102.395,28.5a13.242,13.242,0,0,0-10.02-4.469,12.717,12.717,0,0,0-9.567,4.307V23.047A8.481,8.481,0,0,0,88.033,10.6h0L82.523,1.06a2.119,2.119,0,0,0-3.671,0L73.342,10.6a8.481,8.481,0,0,0,5.226,12.445v5.291A12.717,12.717,0,0,0,69,24.031,13.242,13.242,0,0,0,58.981,28.5a15.444,15.444,0,0,0-3.786,10.323c0,8.245,5.994,14.014,15.319,21.938H63.025a2.12,2.12,0,1,0,0,4.239H98.351a2.12,2.12,0,1,0,0-4.239Zm-21.9-45.924a4.234,4.234,0,0,1,.564-2.115l3.675-6.364,3.675,6.364h0a4.239,4.239,0,1,1-7.914,2.115Zm7.844,45.924h-7.21l-1.094-.922C66.02,51.433,59.434,45.881,59.434,38.823c0-6.016,4.113-10.553,9.567-10.553a8.9,8.9,0,0,1,7.383,4.079,16.057,16.057,0,0,1,2.261,4.484,2.12,2.12,0,0,0,4.085,0c.024-.085,2.457-8.564,9.644-8.564,5.454,0,9.567,4.537,9.567,10.553,0,7.057-6.586,12.61-16.555,21.015Z",
    transform: "translate(-55.195 0)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandle5);
export default __webpack_public_path__ + "static/media/candle-5.21df943f5667aa000004fbbf4cadf661.svg";
export { ForwardRef as ReactComponent };